<template>
  <section class="story">
    <div class="container">
      <div class="story-inner">
        <span class="label">{{ t('story.tag') }}</span>
        <blockquote class="serif" v-html="t('story.quote')"></blockquote>
        <cite v-html="t('story.cite')"></cite>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()
</script>

<style scoped>
.story {
  background: var(--bg-warm);
  padding: 120px 0;
}
@media (max-width: 768px) {
  .story { padding: 56px 0; }
}
.story-inner { max-width: 800px; margin: 0 auto; }
.story .label {
  display: inline-block;
  background: var(--ink);
  color: var(--bg);
  padding: 8px 18px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 36px;
  border-radius: 999px;
}
.story blockquote {
  font-family: 'Fraunces', serif;
  font-size: clamp(32px, 5vw, 52px);
  line-height: 1.1;
  letter-spacing: -0.025em;
  font-weight: 700;
  margin-bottom: 40px;
  position: relative;
}
.story blockquote :deep(.highlight) {
  background: var(--yellow);
  padding: 0 10px;
  border-radius: 6px;
}
.story cite {
  display: block;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  color: var(--ink-soft);
}
.story cite::before { content: '\2014\00a0'; }
</style>
